import produce from 'immer';
import { combineReducers } from 'redux';
import {
  CurrentUserEditingDetails,
  CurrentUserUpdateDetails,
  UserAction,
  UserActionType,
} from '../../actions/userActions';

type LoadingState = { loading: boolean; loadingError: string };
type DeletingState = { deleting: boolean; deletingError: string };
type DeletingPersonalWorkspaceDataState = {
  deletingPersonalWorkspaceData: boolean;
  deletingPersonalWorkspaceDataError: string;
};
type EditingStates = {
  [editingStatusKey in CurrentUserEditingDetails['statusKey']]: boolean;
};
type EditingErrors = {
  [editingErrorKey in CurrentUserEditingDetails['errorKey']]: string;
};

type UpdatingStates = {
  [editingStatusKey in CurrentUserUpdateDetails['statusKey']]: boolean;
};
type UpdatingErrors = {
  [editingErrorKey in CurrentUserUpdateDetails['errorKey']]: string;
};

export type CurrentUserState = LoadingState &
  DeletingState &
  DeletingPersonalWorkspaceDataState &
  EditingStates &
  EditingErrors &
  UpdatingStates &
  UpdatingErrors;

const current = (state: CurrentUserState = {} as CurrentUserState, action: UserAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case UserActionType.GET_CURRENT_USER:
        draft.loading = true;
        draft.loadingError = '';
        break;
      case UserActionType.GET_CURRENT_USER_OK:
        draft.loading = false;
        break;
      case UserActionType.GET_CURRENT_USER_ERROR:
        draft.loading = false;
        draft.loadingError = action.error;
        break;
      case UserActionType.DELETE_CURRENT_USER:
        draft.deleting = true;
        draft.deletingError = '';
        break;
      case UserActionType.DELETE_CURRENT_USER_OK:
        draft.deleting = false;
        break;
      case UserActionType.DELETE_CURRENT_USER_ERROR:
        draft.deleting = false;
        draft.deletingError = action.error;
        break;
      case UserActionType.DELETE_PERSONAL_WORKSPACE_DATA:
        draft.deletingPersonalWorkspaceData = true;
        draft.deletingPersonalWorkspaceDataError = '';
        break;
      case UserActionType.DELETE_PERSONAL_WORKSPACE_DATA_OK:
        draft.deletingPersonalWorkspaceData = false;
        break;
      case UserActionType.DELETE_PERSONAL_WORKSPACE_DATA_ERROR:
        draft.deletingPersonalWorkspaceData = false;
        draft.deletingPersonalWorkspaceDataError = action.error;
        break;
      case UserActionType.EDIT_CURRENT_USER:
        draft[action.statusKey] = true;
        draft[action.errorKey] = '';
        break;
      case UserActionType.EDIT_CURRENT_USER_OK:
        draft[action.statusKey] = false;
        break;
      case UserActionType.EDIT_CURRENT_USER_ERROR:
        draft[action.statusKey] = false;
        draft[action.errorKey] = action.error;
        break;
      case UserActionType.UPDATE_CURRENT_USER_DETAILS:
        draft[action.statusKey] = true;
        draft[action.errorKey] = '';
        break;
      case UserActionType.UPDATE_CURRENT_USER_DETAILS_OK:
        draft[action.statusKey] = false;
        break;
      case UserActionType.UPDATE_CURRENT_USER_DETAILS_ERROR:
        draft[action.statusKey] = false;
        draft[action.errorKey] = action.error;
        break;
      default:
        return state;
    }
  });

export default combineReducers({ current });
